module.exports = __webpack_public_path__ + "static/img/nine9.ff18be3f.jpg";